import { DateField } from '@common';
import { Grid } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export const VersionFormFields: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Grid>
      <Grid.Col span={6}>
        <DateField
          fieldName="validFrom"
          label={t(`VERSION_FORM_FIELDS.VALID_FROM_LABEL`)}
          required
        />
      </Grid.Col>
      <Grid.Col span={6}>
        <DateField
          fieldName="validUntil"
          label={t(`VERSION_FORM_FIELDS.VALID_UNTIL_LABEL`)}
        />
      </Grid.Col>
    </Grid>
  );
};
